import * as turf from '@turf/turf';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

export const MakeMap = (container, center, interactive = true) => {
  return {
    container: container,
    style: 'mapbox://styles/mapbox/streets-v12',
    center: center ? [center[0], center[1]] : [106.6702061, -6.1831357],
    zoom: 10,
    interactive: interactive,
    maxBounds: [
      [94.36405868758938, -11.650356606220004],
      [141.95026998017508, 6.763051702954545],
    ],
    projection: 'naturalEarth',
  };
};

export const MakeCurveLine = (origin, destination) => {
  const radius = turf?.rhumbDistance(origin, destination);
  const midpoint = turf?.midpoint(origin, destination);
  const bearing = turf?.rhumbBearing(origin, destination) - 90;

  const point = turf?.rhumbDestination(midpoint, radius, bearing);
  return turf?.lineArc(
    point,
    turf?.distance(point, origin),
    turf?.bearing(point, destination),
    turf?.bearing(point, origin),
    { steps: 200 }
  );
};

export const MakeArrow = (map, loc) => {
  return new mapboxgl.Marker().setLngLat(loc);
};

export const MakeMarker = (
  loc,
  type,
  text,
  color = '#2f83ba',
  is_active = null
) => {
  var el = document.createElement('div');
  el.className = 'mapboxgl-nvo-marker';
  el.innerHTML = `<div class="mapboxgl-nvo-point ${type} ${
    is_active ? 'active' : ''
  } " style="background-color:${color};"><b>${text}</b></div>`;

  return new mapboxgl.Marker(el).setLngLat(loc);
};

export const PinContent = (location, t) => {
  return `<div class='tooltip-contentss'>
    <small>${location?.name}</small>
    <p>${location?.address}</p>

    <small>${location?.region?.district_name || ''}, ${location?.region?.regency_name || ''}, ${location?.region?.province_name || ''}</small>
    <small>${location?.contact_person || ''} ${location?.contact_person && location?.phone_number ? '/' : ''} ${location?.phone_number || ''}</small><br />

    <small> Tipe : ${t?.replace('_point', '', 0)} POINT</small>
  </div>`;
};
